
export const camelCaseToSentence = (text: string) => {
  const label = text.replace(/([A-Z])/g, ' $1').trim()
  return label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()
}

// eslint-disable-next-line
const tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/

export const validateEmail = (email: string): boolean => {
  const valid = tester.test(email)
  if (!email || email.length > 254 || !valid) {
    return false
  }
  return true
}

interface MetadataObj {
  [key: string]: any
}

export const DATE_PARAMS = ['dob']

// @ts-ignore
export const reduceParams = (obj: MetadataObj) => {
  return Object.keys(obj).reduce((acc, key) => {
    if (
      !obj[key] ||
      (obj[key] && Array.isArray(obj[key]) && obj[key].length === 0)
    ) {
      return acc
    }

    // if (DATE_PARAMS.includes(key) && obj[key]) {
    //   return { ...acc, [key]: formatDateFromString(obj[key])}
    // }

    if (obj[key] && obj[key].value && obj[key].label) {
      return { ...acc, [key]: obj[key].value }
    }

    if (obj[key]) {
      return { ...acc, [key]: obj[key] }
    }

    return acc
  }, {})
}

export const passwordValidation = (value: string | undefined) => {
  const strings = value ? value : ''
  let character = ''
  let isHaveUpperCase = false
  let isHaveLowerCase = false
  let isHaveNumber = false
  for (let i = 0; i < strings.length; i++) {
    character = strings.charAt(i)
    // @ts-ignore
    if (!isNaN(character * 1)) {
      isHaveNumber = true
    } else {
      if (character === character.toUpperCase()) {
        isHaveUpperCase = true
      }
      if (character === character.toLowerCase()) {
        isHaveLowerCase = true
      }
    }
  }
  if (
    value &&
    value.length >= 8 &&
    isHaveUpperCase &&
    isHaveLowerCase &&
    isHaveNumber
  ) {
    return false
  }
  return true
}
